import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { selectLastOrder } from '@/redux/slices/checkout.slice';

export const getLastUserStorageOrder = createAppAsyncThunk(
  'checkout/getLastUserStorageOrder',
  async (_, { rejectWithValue, getState, extra: { checkoutService } }) => {
    try {
      const orderId = selectLastOrder(getState()).id;
      return await checkoutService.getUserLastOrder({ orderId });
    } catch (error) {
      return rejectWithValue({});
    }
  }
);
